import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import Icon from '@components/Icon.vue';

import { faChevronLeft } from '@icons/solid/faChevronLeft';
import { faChevronRight } from '@icons/solid/faChevronRight';
import { faChevronsLeft } from '@icons/solid/faChevronsLeft';
import { faChevronsRight } from '@icons/solid/faChevronsRight';

import type { CalendarItem } from './calendar-state';

/**
 * `CalendarHeader` component props.
 */
export interface Props {
  periodStart: Date;
  periodEnd: Date;
  previousYear: Date | null;
  previousPeriod: Date | null;
  nextPeriod: Date | null;
  previousFullPeriod: Date | null;
  nextFullPeriod: Date | null;
  nextYear: Date | null;
  currentPeriod: Date;
  currentPeriodLabel: string;
  periodLabel: string;
  displayLocale: string;
  displayFirstDate: Date;
  displayLastDate: Date;
  monthNames: string[];
  fixedItems: CalendarItem[];
}

/**
 * `CalendarHeader` component emits.
 */
export type Emits = (event: 'input', day: Date | null) => void;

interface HeaderButtonConfig {
  key: string;
  ariaLabel: string;
  content: string | IconDefinition;
  date: Date | null;
}


const __default__ = { name: 'CalendarHeader' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    periodStart: null,
    periodEnd: null,
    previousYear: null,
    previousPeriod: null,
    nextPeriod: null,
    previousFullPeriod: null,
    nextFullPeriod: null,
    nextYear: null,
    currentPeriod: null,
    currentPeriodLabel: null,
    periodLabel: null,
    displayLocale: null,
    displayFirstDate: null,
    displayLastDate: null,
    monthNames: null,
    fixedItems: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', day: Date | null) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  periodStart: Date;
  periodEnd: Date;
  previousYear: Date | null;
  previousPeriod: Date | null;
  nextPeriod: Date | null;
  previousFullPeriod: Date | null;
  nextFullPeriod: Date | null;
  nextYear: Date | null;
  currentPeriod: Date;
  currentPeriodLabel: string;
  periodLabel: string;
  displayLocale: string;
  displayFirstDate: Date;
  displayLastDate: Date;
  monthNames: string[];
  fixedItems: CalendarItem[];
};





const TODAY = new Date();

const periodLabelElements = computed(() => {
  return props.periodLabel.split(' ').map((part, index) => {
    return { key: index, text: part.trim(), isYear: !!/^\d{4}$/.exec(part) };
  });
});

const buttons = computed(() => {
  const config: HeaderButtonConfig[] = [];

  config.push({
    key: 'previous-year',
    ariaLabel: 'Previous Year',
    content: faChevronsLeft,
    date: props.previousYear,
  });

  config.push({
    key: 'previous-period',
    ariaLabel: 'Previous Period',
    content: faChevronLeft,
    date: props.previousPeriod,
  });

  config.push({
    key: 'today-btn',
    ariaLabel: 'Today',
    content: 'Today',
    date: TODAY,
  });

  config.push({
    key: 'next-period',
    ariaLabel: 'Next Period',
    content: faChevronRight,
    date: props.nextPeriod,
  });

  config.push({
    key: 'next-year',
    ariaLabel: 'Next Year',
    content: faChevronsRight,
    date: props.nextYear,
  });

  return config;
});

return { __sfc: true,props, emit, TODAY, periodLabelElements, buttons, Icon }
}

})